import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as yup from 'yup'
import { Formik, Form as FormikForm } from 'formik'
import history from '../../../lib/history'
import * as transform from '../../../lib/transform'
import routes from '../../../config/routes'
import Button from '../../commons/Button/Button'
import Text from '../../commons/Text/Text'
import TextFieldFormik from '../../commons/Fields/TextFieldFormik'
import Card from '../../commons/Card/Card'
import Flex from '../../commons/Flex/Flex'
import Modal from '../../commons/Modal/Modal'
import styles from './profileDetail.module.scss'

const validationSchema = yup.object().shape({
  phone: yup
    .string()
    .min(13, 'Telefone inválido')
    .required('Telefone requerido')
})

const RegisterPhoneForm = (props) => {
  const { handleSubmit, initialValues } = props
  const [visible, setVisible] = useState(false)

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid }) => {
        const disabled = isSubmitting || !isValid

        return (
          <FormikForm>
            <Card className={styles.cardMargin}>
              <Flex
                column
                alignItems="flex-start"
                justifyContent="space-evenly"
              >
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  bold
                  lineHeight="24px"
                >
                  Alterar telefone
                </Text>
                <TextFieldFormik
                  name="phone"
                  validate="phone"
                  mask="phone"
                  label="Digite seu telefone"
                  transform={transform.toNumber}
                />
              </Flex>
            </Card>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 33
              }}
            >
              <Button
                width="234px"
                buttonType="button"
                margin="0px 16px 0px 0px"
                onClick={() => history.push(routes.profile.path)}
              >
                <Text font="custom" size="xs" color="gray" variation="dark">
                  Cancelar
                </Text>
              </Button>
              <Button
                type="secondary"
                buttonType="submit"
                disabled={disabled}
                width="234px"
              >
                <Text
                  font="custom"
                  color="white"
                  size="xs"
                  value="Confirmar"
                  bold
                />
              </Button>
            </div>
            <Modal visible={visible} centered rounded>
              <Flex
                column
                alignItems="center"
                height="242px"
                justifyContent="space-evenly"
              >
                <Text
                  size="lg"
                  color="gray"
                  variation="dark"
                  extraBold
                  lineHeight="30px"
                >
                  Deseja salvar as alterações?
                </Text>
                <Button
                  type="secondary"
                  buttonType="submit"
                  width="234px"
                  onClick={() => history.push(routes.storeDetail.path)}
                >
                  <Text
                    font="custom"
                    color="white"
                    size="xs"
                    value="Salvar"
                    bold
                  />
                </Button>
                <Button
                  onClick={() => {
                    setVisible(false)
                    history.goBack()
                  }}
                >
                  <Text
                    font="custom"
                    size="xs"
                    lineHeight="20px"
                    color="gray"
                    bold
                    variation="dark"
                  >
                    Descartar
                  </Text>
                </Button>
              </Flex>
            </Modal>
          </FormikForm>
        )
      }}
    </Formik>
  )
}

RegisterPhoneForm.defaultProps = {
  handleSubmit: null,
  initialValues: {
    phone: ''
  }
}

RegisterPhoneForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.shape({
    phone: PropTypes.string
  })
}

export default RegisterPhoneForm
